import {
    Service
  } from '../service.js'
  import {
    env
  } from '../env.js'
  
  class ConfiguracoesService extends Service {
    constructor() {
      super();
  
      this.url = env.baseIdentificacao + "configuracoes";
    }

    async adquirirConfiguracoes() {
      const params = new URLSearchParams();
      params.append('filter[chave.id]', 'GerarBaixaPorLeitura');
      params.append('filter[chave.id]', 'TokenIntegracaoWhatsapp');

      const queryString = params.toString();
      const response = await this.get(`${this.url}?${queryString}`);

      const configuracoes = response?.data || [];
      
      const configLeituraObj = configuracoes.find(c => c.attributes?.tipoChave == 'GERAR_BAIXA_POR_LEITURA');
      const configTokenWppObj = configuracoes.find(c => c.attributes?.tipoChave == 'TOKEN_INTEGRACAO_WHATSAPP');
      
      const configuracaoLeitura = configLeituraObj?.attributes?.valor == "true" ? true : false;
      const configuracaoWpp = (configTokenWppObj?.attributes?.valor && configTokenWppObj.attributes.valor !== "null") ? true : false;

      return {
          GerarBaixaPorLeitura: configuracaoLeitura,
          hasTokenIntegracaoWhatsapp: configuracaoWpp
      }
    }
  }
  
  export const configuracoesService = new ConfiguracoesService()
  